import React from 'react';
import styled from 'styled-components';
import { colors } from '../../../stylesheets';
import { Icon, Text } from '../index';

type Props = {
  type: 'request' | 'product',
  iconName?: string,
  rightTitle?: string,
  className?: string,
  closeNotification: Function,
  viewChat: Function,
};

const StyledRequestAndProductNotification = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  padding: 5px 3px 5px 10px;
  width: ${(props) => (props.type === 'request' ? 200 : 220)}px;
  height: 40px;
  border-radius: 10px 10px 10px 0;
  background: ${colors.lightBlue};

  .view-chat-notification-button {
    cursor: pointer;
  }

  .close-notification-container {
    width: 15%;
    height: 100%;
    position: absolute;
    top: 0;
    right: -15%;
    display: none;
  }

  #close-notification-button {
    background: ${colors.white};
    width: 16px;
    height: 16px;
    border-radius: 8px;
    display: none;
  }

  &:hover {
    .close-notification-container {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    #close-notification-button {
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
  }
`;

const RequestAndProductNotification = ({
  type,
  iconName,
  rightTitle,
  className,
  closeNotification,
  viewChat,
}: Props) => {
  let rightText;
  if (rightTitle) {
    rightText = rightTitle;
  } else {
    if (type === 'request') {
      rightText = 'درخواست جدید';
    } else {
      rightText = 'درخواست محصول جدید';
    }
  }

  return (
    <StyledRequestAndProductNotification type={type} className={className}>
      <div className="d-flex align-items-center justify-content-between">
        {type === 'product' && <Icon name={iconName} color="primary" />}
        <Text size="sm" className="mr-1">
          {rightText}
        </Text>
      </div>

      <Text
        size="sm"
        color="primaryText"
        className="view-chat-notification-button"
        onClick={viewChat}
      >
        مشاهده
      </Text>

      <div className="close-notification-container">
        <Icon
          id="close-notification-button"
          size={9}
          color="blackText"
          name="e-remove"
          onClick={closeNotification}
        />
      </div>
    </StyledRequestAndProductNotification>
  );
};

export default RequestAndProductNotification;
